import { isServer } from './device-utils';

export type PlaceholderFootballType = 'CompetitionLogo' | 'Flag' | 'PlayerAvatar' | 'TeamLogo' | 'TeamMarketLogo';

export const COMPETITIONLOGO: PlaceholderFootballType = 'CompetitionLogo';
export const FLAG: PlaceholderFootballType = 'Flag';
export const PLAYERAVATAR: PlaceholderFootballType = 'PlayerAvatar';
export const TEAMLOGO: PlaceholderFootballType = 'TeamLogo';
export const TEAMMARKETLOGO: PlaceholderFootballType = 'TeamMarketLogo';

export const getUrlStatic = (): string => {
  const hostname: string = isServer() ? '' : window.location.hostname ?? '';

  switch (
    hostname // TODO change this
  ) {
    case 'dev.cms.sky.it':
    case 'dev.sport.sport.sky.it':
    case 'dev.sport.sky.it':
      return 'dev.static.sky.it';
    case 'test.cms.sky.it':
    case 'test.sport.sport.sky.it':
    case 'test.sport.sky.it':
      return 'test.static.sky.it';
    default:
      // "sport.sky.it"
      return 'static.sky.it';
  }
};

export const placeholdersMap: {
  [key in PlaceholderFootballType]: string;
} = {
  [COMPETITIONLOGO]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/football/competition-logo.png`,
  [FLAG]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/motorsports/gp-flag.png`, // FIXME: should be inside placeholders/football
  [PLAYERAVATAR]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/football/player-avatar.png`,
  [TEAMLOGO]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/football/team-logo.png`,
  [TEAMMARKETLOGO]: `https://${getUrlStatic()}/images/skysport/configurations/placeholders/football/team-market-logo.png`,
};

/**
 * Get COUNTRY FLAG
 * @param country Country Code in ISO-3166 alpha-3 format
 * @returns URL of COUNTRY FLAG on static.sky.it
 */
export const getFlag = (country: string): string =>
  country && country.length === 3
    ? `https://${getUrlStatic()}/images/skysport/it/common/flags/${country.toLowerCase()}.svg`
    : placeholdersMap[FLAG];
